import React from "react";
import Header from "../../header/header";
import { Button } from "reactstrap";
import "./style.css";
import Axios from "axios";
import { config } from "./config";
import S3 from "aws-s3";
import * as constants from "../../../../utils/constants";
import { Link, Redirect } from "react-router-dom";
import { sendData } from "../../../../analytics/sendData";
import { FormattedMessage } from "react-intl";
import Loader from "./../../loader/loader";
import { formatDate } from "./../../../../utils/helper";
class AddAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      location: "",
      options: [
        {
          display: <FormattedMessage id="opt1" defaultMessage="Horoscope" />,
          name: "Horoscope",
          value: false,
        },
        {
          display: (
            <FormattedMessage id="opt2" defaultMessage="Coffee Cup Reading" />
          ),
          name: "Coffee Cup Reading",
          value: false,
        },
        {
          display: (
            <FormattedMessage id="opt3" defaultMessage="Tarot Card Reading" />
          ),
          name: "Tarot Card Reading",
          value: false,
        },
        {
          display: <FormattedMessage id="opt4" defaultMessage="Zodiac Signs" />,
          name: "Zodiac Signs",
          value: false,
        },
        {
          display: (
            <FormattedMessage id="opt5" defaultMessage="Future Prediction" />
          ),
          name: "Future Prediction",
          value: false,
        },
      ],
      imageurl: "",
      uid: sessionStorage.getItem("rockmanId"),
      redirect: false,
      contentloading: 0,
    };
  }

  componentDidMount() {
    sendData("", "my-account", "viewed");
    var uid = JSON.parse(sessionStorage.getItem("uid")).uid;
    var rid = sessionStorage.getItem("rockmanId");
    const countryCode = JSON.parse(
      sessionStorage.getItem("countryCode")
    ).countryCode;
    if (rid !== null && countryCode == "bh") {
      Axios.get(
        //`https://eu-api.sam-media.com/api/v1/subscription/validate-access-token/sammediacp?accessToken=${uid}`,
        `https://de-mcb-api.sam-media.com/mcb/api/v2/validate-access/sam?token=${uid}`,
        {
          onDownloadProgress: () => {
            this.setState({ contentloading: 1 });
          },
        }
      )
        .then((response) => {
          let { subscribed_at, next_renewal_date, msisdn } = response.data;
          if (
            subscribed_at &&
            subscribed_at != "(not-set)" &&
            next_renewal_date &&
            msisdn
          ) {
            sessionStorage.setItem("start_date", subscribed_at);
            sessionStorage.setItem("end_date", next_renewal_date);
            sessionStorage.setItem("msisdn", msisdn);
          }
          this.setState({ contentloading: 0 });
        })
        .catch((e) => {
          console.log(e);
          this.setState({ contentloading: 0 });
        });
    }
    Axios.get(`${constants.BASE_URL}/account/update?uid=${rid}`, {
      onDownloadProgress: () => {
        this.setState({ contentloading: 1 });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          let { name, email, location, imageurl, interestOptions } =
            response.data;

          // Getting Back Option object
          let response_option = interestOptions.split(",");
          let new_options = this.state.options;
          new_options.forEach((item) => {
            response_option.forEach((item2) => {
              if (item.name == item2) item.value = true;
            });
          });

          this.setState({
            name: name,
            email: email,
            location: location,
            imageurl: imageurl,
            options: new_options,
            uid: sessionStorage.getItem("rockmanId"),
            contentloading: 0,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ contentloading: 0 });
      });
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onCheck = (e) => {
    let optionsNew = this.state.options;
    optionsNew.forEach((item) => {
      if (item.name === e.target.name) item.value = e.target.checked;
    });
    this.setState({ options: optionsNew });
  };

  onSubmit = (e) => {
    e.preventDefault();

    let regExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Checking Methods
    if (
      this.state.email === "" ||
      this.state.name === "" ||
      this.state.location === ""
    )
      return alert(
        <FormattedMessage
          id="fillfields"
          defaultMessage="Please fill all the fields"
        />
      );
    if (this.state.email !== "" && !regExp.test(this.state.email)) {
      return alert(
        <FormattedMessage
          id="invalidmail"
          defaultMessage="Your email-address is invalid.\nCheck your email address"
        />
      );
    }
    if (this.state.imageurl === "") {
      return alert(
        <FormattedMessage
          id="uploadimg"
          defaultMessage="Please upload an image"
        />
      );
    }

    // Post to database
    Axios.post(`${constants.BASE_URL}/account`, this.state, {
      onDownloadProgress: () => {
        this.setState({ contentloading: 1 });
      },
    })
      .then((response) => {
        if (response.status === 200) {
          alert(response.data.msg);
        }
        this.setState({ redirect: true, contentloading: 0 });
        window.location.reload();
      })
      .catch((error) => alert(error.response.data.msg));
  };

  imageUploadHandler = (e) => {
    const S3Client = new S3(config);
    let isUploaded = false;
    if (e.target.files[0] && e.target.files[0].size < 2000000) {
      isUploaded = true;
    } else {
      alert(
        <FormattedMessage
          id="filesize"
          defaultMessage="File size too large.\nMaximum allowed size is 2MB"
        />
      );
    }
    if (isUploaded) {
      S3Client.uploadFile(e.target.files[0])
        .then((response) => {
          console.log(response.location);
          this.setState({ imageurl: response.location });
        })
        .catch((err) => {
          alert(
            <FormattedMessage
              id="errimg"
              defaultMessage="Error in uploading image"
            />
          );
        });
    }
  };

  render() {
    const { name, email, options, location, redirect, contentloading } =
      this.state;
    const countryCode = JSON.parse(
      sessionStorage.getItem("countryCode")
    ).countryCode;
    var start_date = sessionStorage.getItem("start_date");
    var end_date = sessionStorage.getItem("end_date");
    var msisdn = sessionStorage.getItem("msisdn");
    var style = "";
    countryCode == "bh" ? (style = "account-main-2") : (style = "account-main");
    if (redirect) {
      return <Redirect to="/" />;
    }
    if (contentloading) {
      return <Loader />;
    }
    return (
      <div style={{ height: "112vh" }}>
        <Header />
        <div className={style}>
          <input
            type="file"
            name="photo"
            id="photo"
            accept="image/jpg, image/png, image/jpeg"
            hidden
            onChange={this.imageUploadHandler}
          />
          <label className="userimg" htmlFor="photo">
            <img
              src={
                this.state.imageurl
                  ? this.state.imageurl
                  : require("./../../../assets/images/UserImage.jpg")
              }
              alt="User Photo"
            />
          </label>
          <div className="details">
            <label className="account-label" htmlFor="name">
              <FormattedMessage id="name" defaultMessage="Name:" />
            </label>
            <input
              type="text"
              id="name"
              className="account-input"
              name="name"
              value={name}
              onChange={this.onInputChange}
            />
            <label className="account-label" htmlFor="email">
              <FormattedMessage id="email" defaultMessage="Email:" />
            </label>
            <input
              type="email"
              id="email"
              className="account-input"
              name="email"
              value={email}
              onChange={this.onInputChange}
            />
            <label className="account-label" htmlFor="location">
              <FormattedMessage id="loc" defaultMessage="Location:" />
            </label>
            <input
              type="text"
              id="location"
              className="account-input"
              name="location"
              value={location}
              onChange={this.onInputChange}
            />
            {countryCode === "bh" ? (
              <div>
                <label className="account-label" htmlFor="location">
                  {" "}
                  User Details:
                </label>
                <ul style={{ listStyleType: "none" }}>
                  <li className="user-details">
                    Mobile Number: <strong>{msisdn}</strong>
                  </li>
                  <li className="user-details">
                    Start Date:{" "}
                    <strong>{formatDate(start_date, "DD/MM/YYYY")}</strong>
                  </li>
                  <li className="user-details">
                    End Date:{" "}
                    <strong>{formatDate(end_date, "DD/MM/YYYY")}</strong>
                  </li>
                </ul>
              </div>
            ) : null}
          </div>

          {/* <div className="checkbox-label"><FormattedMessage id="interests"
                                    defaultMessage="Choose your interests:"
                                /> </div>
                {options.map( item => {
                    return(
                        <div key={item.name} style={{marginBottom: '1.2%'}}>
                            <input type="checkbox" name={item.name} id={item.name} checked={item.value} onChange={this.onCheck} className="css-checkbox" /><label htmlFor={item.name} className="css-label">{item.display}</label>
                        </div>
                        
                    );
                })}  */}
          <Link to="/">
            <Button outline className="submit-butn" onClick={this.onSubmit}>
              <strong>
                <FormattedMessage id="save" defaultMessage="Save" />
              </strong>
            </Button>
          </Link>

          {countryCode == "bh" ? (
            <div>
              <a
                className="unsub"
                href="http://n.mobioastro.com/unsubscribe/bh?lang=en&token="
              >
                Unsubscribe
              </a>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default AddAccount;



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/addAccount/addAccount.js